import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "29 -28 65 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"29 -28 65 64\" id=\"icon-play\"><path fill=\"param(fill) none\" stroke=\"param(outline) #000\" class=\"st0\" d=\"M53.5 17.5v-28l24 14z\" /><path fill=\"param(fill) none\" stroke=\"param(outline) #000\" d=\"M61.5 35.5c-17.6 0-32-14.1-32-31.5s14.4-31.5 32-31.5 32 14.1 32 31.5-14.4 31.5-32 31.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol